import React from 'react'
import { Link, Navigate } from 'react-router-dom'
import { AuthForm } from '../../../../components/AuthForm/AuthForm'
import { LoadingForm } from '../../../../components/LoadingForm/LoadingForm'
import { Title } from '../../../../components/Title/Title'
import { ROUTES } from '../../../../constants/routes'
import { useAuth } from '../../../../hooks/useAuth'
import { RecoverPasswordForm } from './components/RecoverPasswordForm'
import { useFetchRecoveryCode } from './hooks/useFetchRecoveryCode'

export const RecoverPassword = (): React.ReactElement => {
  const { user, isLoading } = useAuth()
  const { isValid, isLoading: isLoadingCode, isError, handleResetPassword } = useFetchRecoveryCode()

  if (isLoading || isLoadingCode) {
    return (
      <>
        <Title value="Account Recovery" />
        <AuthForm useProgress={false}>
          <LoadingForm />
        </AuthForm>
      </>
    )
  }

  if (isError || !isValid) {
    return (
      <>
        <Title value="Invalid Recovery Code" />
        <AuthForm useProgress={false}>
          <h4>Invalid Recovery Code</h4>
          <p>The recovery code has either expired or is invalid.</p>
          <Link to={ROUTES.LOGIN} className="d-block">
            Return to login
          </Link>
        </AuthForm>
      </>
    )
  }

  if (user) {
    return <Navigate to={ROUTES.DASHBOARD} replace />
  }

  return (
    <>
      <Title value="Account Recovery" />
      <AuthForm useProgress={false}>
        <RecoverPasswordForm onSubmit={handleResetPassword} />
      </AuthForm>
    </>
  )
}
